import styled from '@emotion/styled';
import { useCallback, useMemo } from 'react';

const StyledHeroContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  text-align: center;
`;

const StyledTitle = styled.h1`
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 48px;
  line-height: 50px;
  margin: 0;
  color: #333;
`;

const StyledHighlight = styled.span`
  color: #006efa;
`;

const StyledSubtitle = styled.p`
  font-family: 'Centra No1';
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  margin: 0;
  color: #333;
`;

export const PricingHero = ({ product }: { product: string }) => {
  const getTitleAndDescription = useCallback(() => {
    switch (product) {
      case 'AVATAR_STUDIO':
        return {
          title: 'Kaltura',
          highlight: 'Conversation Agent Studio',
          description: 'Build agents that guide users through personalized experiences.',
        }
      default:
        return {
          title: 'Choose your plan',
          description: 'Explore our range of products and find the right fit for your needs.',
        }
    }
  }, [product]);

  const { title, highlight, description } = useMemo(() => getTitleAndDescription(), [getTitleAndDescription]);

  return (
    <StyledHeroContainer>
      <StyledTitle>
        {title} {highlight && <StyledHighlight>{highlight}</StyledHighlight>}
      </StyledTitle>
      <StyledSubtitle>
        {description}
      </StyledSubtitle>
    </StyledHeroContainer>
  );
};
